// extracted by mini-css-extract-plugin
module.exports = {"TextEditor":"TextEditor_TextEditor__2BIYD","Buttons":"TextEditor_Buttons__1J0Yw","Field":"TextEditor_Field__LB-lS"};